"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectBox = void 0;
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const classFunctions_1 = require("../../utils/classFunctions");
require("./index.scss");
const className = 'selectbox';
const SelectOption = (props) => {
    const { item } = props;
    const { label, value } = item;
    if (react_1.default.isValidElement(label)) {
        // processing of the FormattedMessage `label` property
        return (react_1.default.createElement(react_intl_1.FormattedMessage, { ...label.props }, message => (react_1.default.createElement("option", { value: value, key: value }, message))));
    }
    return (react_1.default.createElement("option", { value: value }, label));
};
const SelectBox = (props) => {
    const { name, value, onChange, items, allowEmptyValue, disabled, placeholder = '', modificators, } = props;
    const selectedItem = items === null || items === void 0 ? void 0 : items.find(item => item.value === value);
    const classNames = (0, classFunctions_1.getClassNames)(className, [
        modificators,
        disabled ? 'disabled' : undefined,
    ]);
    return (react_1.default.createElement("div", { className: classNames },
        react_1.default.createElement("div", { className: (0, classFunctions_1.getClassNames)(`${className}__values`, [
                selectedItem ? undefined : 'placeholder',
            ]) }, (selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.label) || placeholder),
        react_1.default.createElement("div", { className: `${className}__arrow` },
            react_1.default.createElement("i", null)),
        react_1.default.createElement("select", { id: 'select', name: name, value: value, disabled: disabled, onChange: onChange },
            (allowEmptyValue || !selectedItem) ? (react_1.default.createElement("option", { value: '' })) : undefined, items === null || items === void 0 ? void 0 :
            items.filter((item) => !item.hidden).map((item) => (react_1.default.createElement(SelectOption, { key: item.value, item: item }))))));
};
exports.SelectBox = SelectBox;
//# sourceMappingURL=index.js.map